import React, { useContext, useEffect, useState } from "react";
import AdminLogin from "../AdminNav/Login";  
import { Box, Flex, Grid, Heading, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { MyContext } from "../../MyProvider";
import { EmptyState, Panel, SectionTitle, StatusMark } from "../../components/ui";

const today=new Date().toLocaleDateString("en-GB");

function Welcome() {
  
  // Fetch existing YouTube links when the component mounts
  
  const{eventData,horoData,appointData}=useContext(MyContext);
  const [counts, setCounts] = useState({
    eventLatest: 0,
    appointLatest: 0,
    astroLatest: 0,
    eventToday: 0,
    appointToday: 0, 
    eventPending:0,
    appointPending:0,
    astroPending:0
  });

  useEffect(() => {
    
    const updatedCounts = {
      eventLatest: eventData.filter((ele) => ele.eventName != "Kashiyatra").filter((ev)=>ev.bookingDate==today).length,
    appointLatest: appointData.filter((ap)=>ap.bookingDate==today).length,
    astroLatest: horoData.filter((ho)=>ho.horoDate==today).length,
    eventToday: eventData.filter((ele) => ele.eventName != "Kashiyatra").filter((ev)=>ev.eventDate==today).length,
    appointToday: appointData.filter((ap)=>ap.appointmentDate==today).length, 
    eventPending:eventData.filter((ele) => ele.eventName != "Kashiyatra").filter((ev)=>ev.eventStatus=="Pending").length,
    appointPending:appointData.filter((ap)=>ap.appointmentStatus=="Pending").length,
    astroPending:horoData.filter((ho)=>ho.horoStatus=="Pending").length
    };
    setCounts(updatedCounts);


  }, [eventData,horoData,appointData]);

  

  
  const token = localStorage.getItem("AdminToken");
  if (!token) {
    return <AdminLogin />;
  }

  const daySheet = [
    ...appointData
      .filter((ap) => ap.appointmentDate == today)
      .map((ap) => ({ ...ap, kind: "Appointment", time: ap.appointmentTime, status: ap.appointmentStatus })),
    ...eventData
      .filter((ev) => ev.eventDate == today)
      .map((ev) => ({ ...ev, kind: ev.eventName ? ev.eventName : "Special Event", time: ev.eventTime, status: ev.eventStatus })),
    ...horoData
      .filter((ho) => ho.horoDate == today)
      .map((ho) => ({ ...ho, kind: "Astro request", status: ho.horoStatus })),
  ].sort((a, b) => (a.time || "99:99").localeCompare(b.time || "99:99"));

  const attention = [
    { to: "/admin/appointments", label: "Appointments pending", count: counts.appointPending },
    { to: "/admin/Events", label: "Events pending", count: counts.eventPending },
    { to: "/admin/astro", label: "Astro requests pending", count: counts.astroPending },
    { to: "/admin/appointments", label: "Appointments booked today", count: counts.appointLatest },
    { to: "/admin/Events", label: "Events booked today", count: counts.eventLatest },
    { to: "/admin/astro", label: "Astro requests today", count: counts.astroLatest },
  ];

  return (
    <>
      <Heading as="h1" fontSize={{ base: "4xl", md: "6xl" }} lineHeight="1.1">
        {new Date().toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long" })}
      </Heading>
      <Text color="stone.500" mb={6}>
        {daySheet.length === 1 ? "1 entry" : `${daySheet.length} entries`} on today's sheet
      </Text>

      <Grid templateColumns={{ base: "1fr", xl: "minmax(0, 2fr) minmax(280px, 1fr)" }} gap={6} alignItems="start">
        <Panel overflow="hidden">
          {daySheet.length === 0 ? (
            <EmptyState>Nothing is scheduled today.</EmptyState>
          ) : (
            daySheet.map((entry) => (
              <Grid
                as={Link}
                to={`/admin/usersDtails/${entry.userId}`}
                key={entry._id}
                templateColumns="84px minmax(0, 1fr) auto"
                gap={4}
                alignItems="center"
                px={5}
                py={3}
                borderBottom="1px solid"
                borderColor="stone.200"
                _last={{ borderBottom: "none" }}
                _hover={{ bg: "stone.50" }}
              >
                <Text fontWeight={600} fontSize="lg">
                  {entry.time ? entry.time : "No time"}
                </Text>
                <Box minW={0}>
                  <Text fontWeight={600}>
                    {entry.fname} {entry.lname}
                  </Text>
                  <Text fontSize="sm" color="stone.500">
                    {entry.kind}
                  </Text>
                </Box>
                <StatusMark status={entry.status} />
              </Grid>
            ))
          )}
        </Panel>

        <Box>
          <SectionTitle>Needs attention</SectionTitle>
          {attention.map((item) => (
            <Flex
              as={Link}
              to={item.to}
              key={item.label}
              justify="space-between"
              py={2}
              borderBottom="1px solid"
              borderColor="stone.300"
              _hover={{ color: "kumkum.500" }}
            >
              <Text>{item.label}</Text>
              <Text fontWeight={600}>{item.count}</Text>
            </Flex>
          ))}
        </Box>
      </Grid>
    </>
  );
}

export default Welcome;
